var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgProfileOutlined = function SvgProfileOutlined(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 1.992c3.345 0 5.99 2.655 5.99 5.85 0 1.848-.886 3.513-2.278 4.59a9.5 9.5 0 0 1 3.02 1.998 9.2 9.2 0 0 1 2.768 6.562c0 .552-.473 1-1.056 1-.582 0-1.055-.448-1.055-1a7.26 7.26 0 0 0-2.178-5.175A7.44 7.44 0 0 0 12 13.692c-1.947 0-3.822.76-5.21 2.125a7.26 7.26 0 0 0-2.179 5.175c0 .552-.472 1-1.055 1s-1.056-.448-1.056-1c0-2.454.992-4.816 2.769-6.562a9.5 9.5 0 0 1 3.018-1.997C6.895 11.355 6.01 9.69 6.01 7.843c0-3.196 2.645-5.85 5.99-5.85m0 2c-2.106 0-3.879 1.69-3.879 3.85 0 2.094 1.664 3.744 3.682 3.846l.197.004.196-.005c2.019-.1 3.683-1.75 3.683-3.844 0-2.162-1.773-3.85-3.879-3.85",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProfileOutlined);
export default ForwardRef;